import React, { useEffect, useRef, useState } from "react";
import { PageHeader, Form, Row, Col, Descriptions, Table, Button } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { useApiContext } from "../../hooks/useApiContext";
import { useReactToPrint } from "react-to-print";
import { Items } from "../../services/items";
import QRCode from "react-qr-code";
import moment from "moment";
import apis from "../../services/apis";
import InvoiceItems from "../../components/invoice/InvoiceItems";
import InvoicePrint from "../../components/invoice/InvoiceDetailPrint";

export default function InvoiceDetails() {
  let printRef = useRef();
  const { invoicedispatch, invoices, items, invoiceItemdispatch } =
    useApiContext();
  const [invoiceData, setInvoiceData] = useState();
  const { id } = useParams();
  useEffect(() => {
    if (id) {
      apis.Invoices.get(invoicedispatch, id).then((res) =>
        setInvoiceData(res.data),
        
      );
    }
  }, [id]);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => {
      // Items.remove(invoiceItemdispatch, [])
      // setCustomField1("")
      // setCustomField2("")
      // setCustomField3("")
      // setCustomField4("")
      // setCustomField5("")
      // // setCustomField6("")
      // invoiceForm.resetFields()
      // setEnablePrinting(false)
      // setIsSaved(true)
      // window.location.reload();
    },
  });
  console.log("Invoice data", invoiceData);
  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Invoice Details"
        subTitle="Find the list of invoice details"
      />
      {invoiceData && (
        <>
          <Descriptions bordered labelStyle={{ fontWeight: "bold" }}>
            <Descriptions.Item label="Invoice Number" span={2}>
              {invoiceData.invoiceNumber}
            </Descriptions.Item>
            <Descriptions.Item label="Project Name">
              {invoiceData.project.projectName}
            </Descriptions.Item>
            <Descriptions.Item label="Business Name" span={2}>
              {invoiceData.business.businessName}
            </Descriptions.Item>
            <Descriptions.Item label="Invoice Date">
              {moment(invoiceData.invoiceDate).format("DD/MM/YYYY")}
            </Descriptions.Item>
            <Descriptions.Item label="Invoice Duration" span={2}>{`${moment(
              invoiceData.startDate
            ).format("DD/MM/YYYY")}-${moment(invoiceData.endDate).format(
              "DD/MM/YYYY"
            )}`}</Descriptions.Item>
            <Descriptions.Item label={invoiceData.customField1}>
              {invoiceData.customField2}
            </Descriptions.Item>
            <Descriptions.Item label={invoiceData.customField3} span={2}>
              {invoiceData.customField4}
            </Descriptions.Item>
            <Descriptions.Item label={invoiceData.customField5}>
              {invoiceData.customField6}
            </Descriptions.Item>
            <Descriptions.Item label="QR Code">
              <QRCode size={100} value={invoiceData.qrValue} />
            </Descriptions.Item>
          </Descriptions>
          <Button
            onClick={handlePrint}
            type="primary"
            style={{ marginRight: "5px" }}
          >
            Print Invoice
          </Button>
          <table class="table table-bordered">
            <thead>
              <tr>
                <td>
                  البند
                  <br />
                  item
                </td>
                <td>
                  الوصف
                  <br />
                  Description
                </td>
                <td>
                  السعر
                  <br />
                  Price
                </td>
                <td>
                  الكمية
                  <br />
                  Quantity
                </td>
                <td>
                  قيمة الضريبة
                  <br />
                  Total Amount
                </td>
                <td>
                  الاجمالي مع الضريبة
                  <br />
                  Total with VAT
                </td>
              </tr>
            </thead>
            <tbody>
              {invoiceData.invoiceItems.map((item, i) => (
                <>
                  {console.log("items :: ", item)}
                  <tr>
                    <td>{i == 0 ? 1 : i + 1}</td>
                    <td>{item.description}</td>
                    <td>{item.price}</td>
                    <td>{item.quantity}</td>
                    <td>{(item.price * item.quantity).toFixed(2)}</td>
                    <td>
                      {(
                        item.price * item.quantity +
                        item.price * item.quantity * 0.15
                      ).toFixed(2)}
                    </td>
                  </tr>
                </>
              ))}

              <tr>
                {console.log("invoiceData :: ", invoiceData)}
                <td colSpan={5} class="text-right f-bold p-10">
                  الاجمالي بعد الضريبة
                  <br />
                  Total VAT Amount:
                </td>
                <td><b>
                      SR{" "}
                      {items.length > 0
                        ? items[0].withoutVat
                          ? 0
                          : (
                              items.reduce((a, b) => a + b.amount, 0) * 0.15
                            ).toFixed(2)
                        : []}
                    </b></td>
              </tr>
              <tr>
                <td colSpan={5} class="text-right f-bold p-10">
                  الرصيد المستحق
                  <br />
                  Due Amount:
                </td>
                <td><b>
                      SR{" "}
                      {items.length > 0
                        ? items[0].withoutVat
                          ? items.reduce((a, b) => a + b.amount, 0).toFixed(2)
                          : (
                              items.reduce((a, b) => a + b.amount, 0) +
                              items.reduce((a, b) => a + b.amount, 0) * 0.15
                            ).toFixed(2)
                        : []}
                    </b></td>
              </tr>
            </tbody>
          </table>
          {/* <InvoiceItems
          saved={true}
        /> */}
          <div style={{ display: "none" }}>
            <InvoicePrint
              ref={printRef}
              invoiceNo={invoiceData.invoiceNumber}
              startDate={invoiceData.startDate}
              endDate={invoiceData.endDate}
              invoiceDate={invoiceData.invoiceDate}
              projectData={invoiceData.project}
              businees={invoiceData.businees}
              projectVat={invoiceData.productVat}
              customField1={invoiceData.customField1}
              customField2={invoiceData.customField2}
              customField3={invoiceData.customField3}
              customField4={invoiceData.customField4}
              customField5={invoiceData.customField5}
              customField6={invoiceData.customField6}
              stampImage={invoiceData.stampType}
              itemInvoice = {invoiceData}
            />
          </div>
        </>
      )}
    </>
  );
}
